"use client";

import styles from "./AnalysisOverview.module.css";
import TopicBarItem from "./TopicBarItem";
import { TopicBarRow } from "./TopicBarRow";

type Props = {
  rows: TopicBarRow[];
};

export default function TopicBars(props: Props) {
  const { rows } = props;

  return (
    <ul className={styles.items}>
      {rows.map((row) => (
        <TopicBarItem key={row.label} row={row} />
      ))}
    </ul>
  );
}
